import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type TransportationOutboxEventCountsResult = QueryAtomResult<
  typeof transportationOutboxEventCountsQueryAtom
>;

export const transportationOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.transportationOutboxEventCounts',
  () => ({
    transportationOutboxEventCounts: {
      asset: true,
      driver: true,
      service: true,
      route: true,
      truck: true,
      trailer: true,
      containerType: true,
      transportationType: true,
      freightForwarder: true,
      freightLine: true,
      shippingCarrier: true,
    },
  }),
  {
    select: ({ transportationOutboxEventCounts }) =>
      transportationOutboxEventCounts,
  },
);
